import { Grid, TextField } from "@mui/material";
import React, { useState } from "react";

export const InputNumber = (props) => {

    const onTrigger = (event) => {
        (event.target.value < 1) ? setOnError(true) : setOnError(false);

        props.parentCallback(event);
    };

    const [OnError, setOnError] = useState(false);

    return (
        <Grid container spacing={2} sx={{ pl: props.paddingH, pr: props.paddingH, pt: props.paddingV, pb: props.paddingV }}>
            <Grid item xs={props.xs}>
                <TextField
                    // InputProps={{ inputProps: { min: props.valueMin } }}
                    InputProps={{ inputProps: props.inputProps }}
                    defaultValue={props.defaultValue}
                    error={OnError}
                    fullWidth
                    id={props.name}
                    label={props.label}
                    name={props.name}
                    onChange={onTrigger}
                    required={props.required}
                    size="small"
                    type="number"
                    variant={props.variant}
                />
            </Grid>
        </Grid>

    );
}
